import styled from "styled-components";

export const BTScannerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 100px;

  .donebtn {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .barcodeValues {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    gap: 1em;

    p {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      font-size: 14px;

      span {
        font-size: 16px;
        font-weight: 600;
        color: var(--accent);
        display: flex;
        flex-flow: column;
        align-items: flex-start;

        span.suggBox {
          color: #666;
          font-size: 12px;
          display: block;

          b {
            font-size: 16px;
            color: var(--orange);
          }
        }
      }
    }
  }

  .ant-divider {
    margin: 4em 0;
  }

  button.bbtn {
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .toMark {
    text-align: center;
    font-size: 32px;
    width: 100%;
    margin: 1em auto 1em auto;
    color: var(--accent);
  }
`;
